import { render, staticRenderFns } from "./mobileTab.vue?vue&type=template&id=2fd52a98&scoped=true&"
import script from "./mobileTab.vue?vue&type=script&lang=js&"
export * from "./mobileTab.vue?vue&type=script&lang=js&"
import style0 from "./mobileTab.vue?vue&type=style&index=0&id=2fd52a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd52a98",
  null
  
)

export default component.exports